exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-row {\n  width: 100%;\n}\n.uu5-bricks-row:before {\n  display: table;\n  content: \" \";\n}\n.uu5-bricks-row:after {\n  clear: both;\n  display: table;\n  content: \" \";\n}\n.uu5-bricks-row.uu5-bricks-row-flex {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n/* because of iOS */\n.uu5-bricks-row.uu5-bricks-row-flex:before,\n.uu5-bricks-row.uu5-bricks-row-flex:after {\n  content: normal;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/row.less
// module id = 256
// module chunks = 0